import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import LAYOUT from 'constants/layout';
import reactStringReplace from 'react-string-replace';
import COLORS from 'constants/colors';

import styled from 'styled-components';
import { Col, Row, Text } from '@cuemath/comps';
import { COLOR_CODES } from 'constants/feedback';
import { Separator } from '@cuemath/comps';
import { WIDGET, REVIEW } from '../constants';

const CustomRow = styled(Row)`
  & > * {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 767px) {
    display: ${props => (props.transpose ? 'inherit' : 'block')};
  }
`;

const GridRow = styled(Row)`
  & > :first-child {
    padding-left: 0;
  }
  & > :last-child {
    padding-right: 0;
  }
`;

const FeedbackGridRow = styled(Row)`
  flex-wrap: nowrap;
`;

const FeedbackRow = styled(Row)`
  width: 554px;
  box-sizing: border-box;
  border-top: 0.88px solid ${COLORS.SKY_XXLIGHT};
  border-left: 0.88px solid ${COLORS.SKY_XXLIGHT};
  border-radius: 3.52px;
  margin: auto;

  & > * {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 767px) {
    display: ${props => (props.transpose ? 'inherit' : 'block')};
  }
`;

const Label = styled.label`
  max-width: 33.33%;
  padding: 10px;
  border-right: 0.88px solid ${COLORS.SKY_XXLIGHT};
  border-bottom: 0.88px solid ${COLORS.SKY_XXLIGHT};
  background: ${({ checked }) => (checked ? 'aliceblue' : COLORS.WHITE)};
  border: ${({ checked }) => (checked ? `1px solid ${COLORS.SECONDARY}` : '')};
`;

const ValueText = styled(Text)`
  line-height: 20px;
  color: ${COLORS.COLA};
`;

const InputRadio = styled.input`
  box-sizing: border-box;
  margin: 3px 3px 0px 5px;
  border: 0.88px solid rgba(42, 42, 46, 0.3);
  background-color: ${COLORS.WHITE};
`;

export default class RadioInput extends PureComponent {
  static propTypes = {
    feedbackType: PropTypes.string,
    noSeparatorForRadioBtn: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    selected: PropTypes.string,
    transpose: PropTypes.bool,
  };

  static defaultProps = {
    feedbackType: null,
    noSeparatorForRadioBtn: false,
    label: null,
    onChange: () => {},
    selected: null,
    transpose: false,
  };

  onChange = e => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(e.target.value);
    }
  };

  getValue = value => {
    let text = value;

    Object.values(COLOR_CODES).forEach((key, i) => {
      key.forEach(substring => {
        if (text && text.indexOf(substring) > -1) {
          text = reactStringReplace(text, substring, () => (
            <span>
              <font color={Object.keys(COLOR_CODES)[i]}>{substring}</font>
            </span>
          ));
        }
      });
    });

    return <ValueText weight="semibold">{text}</ValueText>;
  };

  getFeedbackMatrix = () => {
    const { name, options, selected } = this.props;

    return (
      <FeedbackRow>
        {options.map(({ id, value }, i) => (
          <Label htmlFor={`${name}_${id}_${i}`} key={id} checked={selected === id}>
            <FeedbackGridRow>
              <InputRadio
                id={`${name}_${id}_${i}`}
                name={name}
                type="radio"
                onChange={this.onChange}
                value={id}
                checked={selected === id}
              />
              {this.getValue(value)}
            </FeedbackGridRow>
          </Label>
        ))}
      </FeedbackRow>
    );
  };

  render() {
    const {
      name,
      label,
      options,
      selected,
      transpose,
      feedbackType,
      noSeparatorForRadioBtn,
    } = this.props;

    const separatorFunc = () => {
      if (noSeparatorForRadioBtn) {
        return null;
      }

      return <Separator height={LAYOUT.SMALL_GAP} />;
    };

    return (
      <Fragment>
        <Text>{label}</Text>

        {!feedbackType && separatorFunc()}
        {feedbackType === WIDGET || feedbackType === REVIEW ? (
          this.getFeedbackMatrix()
        ) : (
          <CustomRow transpose={transpose}>
            {options.map(({ id, value }) => (
              <label htmlFor={`${name}_${id}`} key={id}>
                <Col gap={LAYOUT.SMALL_GAP / 3} gutter={LAYOUT.GUTTER / 2}>
                  <GridRow>
                    <Col gutter={LAYOUT.SMALL_GAP}>
                      <input
                        id={`${name}_${id}`}
                        name={name}
                        type="radio"
                        onChange={this.onChange}
                        value={id}
                        checked={selected === id}
                      />
                    </Col>
                    <Col gutter={LAYOUT.SMALL_GAP}>
                      <Text>{value}</Text>
                    </Col>
                  </GridRow>
                </Col>
              </label>
            ))}
          </CustomRow>
        )}
      </Fragment>
    );
  }
}
